import { useContext } from "react";
import { getLabel } from "../../InitData";
import Img from "../Img";
import { UserContext } from "../../data/betslip/UserConf";

export default function MyBetsButton() {
    const userContext = useContext(UserContext);
    const user = userContext.getUser();
    const isLogged = user?.logged ?? false;

    if (!isLogged) {
        return null;
    }

    return (
        <a href={window.xs_mybetsUrl} target="_self" rel="noreferrer" className="c_6">
            <Img className="c_6_1" src="icon_mybets.svg" height="16px" width="16px" />
            <span className="c_6_2">{getLabel('general.mybets')}</span>
        </a>
    );
}
